const callCenterLoginEvent = ({
  isLoggedIn,
}) => ({
  event: isLoggedIn ? 'callCenterLogin' : 'callCenterLogout',
  callcenter_mode: isLoggedIn || undefined, // set to undefined so that falsy value is always the same
});

export {
  callCenterLoginEvent,
};
